/**
 * Test IDs for QA automation.
 */
export const testIds = {
  assetFiltersDomicile: "asset-filters-domicile",
  assetFiltersDomicileOption: "asset-filters-domicile-option",
} as const;
